import api from './api';

const getPaymentDashboardStats = async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.type) params.append('type', filters.type);
    if (filters.status) params.append('status', filters.status);
    if (filters.regionId) params.append('regionId', filters.regionId);
    if (filters.facilityId) params.append('facilityId', filters.facilityId);
    if (filters.search) params.append('search', filters.search);

    const query = params.toString();
    return api.get(`/api/payment/dashboard/stats${query ? `?${query}` : ''}`);
};

const getPaymentTransactionsPaged = async (page, pageSize, filters = {}) => {
    const params = new URLSearchParams({ page, pageSize });
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.type) params.append('type', filters.type);
    if (filters.status) params.append('status', filters.status);
    if (filters.regionId) params.append('regionId', filters.regionId);
    if (filters.facilityId) params.append('facilityId', filters.facilityId);
    if (filters.search) params.append('search', filters.search);

    const query = params.toString();
    return api.get(`/api/payment/dashboard/transactions${query ? `?${query}` : ''}`);
};

const downloadTransactionsExcel = async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.type) params.append('type', filters.type);
    if (filters.status) params.append('status', filters.status);
    if (filters.regionId) params.append('regionId', filters.regionId);
    if (filters.facilityId) params.append('facilityId', filters.facilityId);
    if (filters.search) params.append('search', filters.search);

    const query = params.toString();
    return api.get(`/api/payment/dashboard/export-excel${query ? `?${query}` : ''}`, {
        responseType: 'blob'
    });
};

export const paymentDashboardService = {
    getPaymentDashboardStats,
    getPaymentTransactionsPaged,
    downloadTransactionsExcel
};
